import { render, staticRenderFns } from "./LoadingP.vue?vue&type=template&id=37629676"
import script from "./LoadingP.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingP.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports